import React from 'react';

export type HandleScrollType = (
  event: React.MouseEvent<HTMLButtonElement, MouseEvent>
) => void;

export type ReferenceType = React.RefObject<HTMLInputElement>;

export const useRefScrollToTop = (): [ReferenceType, HandleScrollType] => {
  const refScroll = React.useRef<HTMLInputElement>(null);

  const handleScroll = (
    event: React.MouseEvent<HTMLButtonElement, MouseEvent>
  ) => {
    event.stopPropagation();
    // eslint-disable-next-line no-unused-expressions
    refScroll?.current?.scrollIntoView({ block: 'start', behavior: 'smooth' });
  };

  return [refScroll, handleScroll];
};
